import { useEffect } from "react";

import { useTracking } from "@/hooks/use-tracking";

interface TrackJobViewedProps {
  jobId: string;
  schoolNcesId: string;
  districtId: string;
  state: string;
}

const trackedJobs = new Set<string>();

export function useTrackJobViewed({
  jobId,
  schoolNcesId,
  districtId,
  state,
}: TrackJobViewedProps) {
  const { trackJobViewed } = useTracking();

  useEffect(() => {
    // Only track if we haven't tracked this job yet in the current session
    if (trackedJobs.has(jobId)) return;
    trackedJobs.add(jobId);

    trackJobViewed({
      jobId,
      schoolNcesId,
      districtId,
      state,
    });
  }, [jobId, schoolNcesId, districtId, state, trackJobViewed]);
}
